import { apiRequest } from "../../services/apiService";
import { ADD_FIELD_FAIL, ADD_FIELD_REQUEST, ADD_FIELD_SUCCESS, DELETE_FIELD_FAIL, DELETE_FIELD_REQUEST, DELETE_FIELD_SUCCESS, UPDATE_FIELD_FAIL, UPDATE_FIELD_ORDER_FAIL, UPDATE_FIELD_ORDER_REQUEST, UPDATE_FIELD_ORDER_SUCCESS, UPDATE_FIELD_REQUEST, UPDATE_FIELD_SUCCESS, UPDATE_STATIC_FIELD_ORDER_FAIL, UPDATE_STATIC_FIELD_ORDER_REQUEST, UPDATE_STATIC_FIELD_ORDER_SUCCESS } from "../constant";

export const addField = (data) => {
    return async (dispatch) => {
        dispatch({ type: ADD_FIELD_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/addLeadGenField`,
            data: data
        })
        if (response) {
            dispatch({ type: ADD_FIELD_SUCCESS, payload: { id: response.data?.data?.insertId, data } })
        }
        else if (error) {
            dispatch({ type: ADD_FIELD_FAIL })
        }
    }
}

export const updateField = (data, successCallback = () => { }, errCallback = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_FIELD_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updLeadGenField`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_FIELD_SUCCESS, payload: data })
            successCallback()
        }
        else if (error) {
            errCallback(error.response?.data?.data?.message)
            dispatch({ type: UPDATE_FIELD_FAIL })
        }
    }
}

export const deleteField = (data) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_FIELD_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delLeadGenField`,
            data: data
        })
        if (response) {
            dispatch({ type: DELETE_FIELD_SUCCESS, payload: data.fieldId })
        }
        else if (error) {
            dispatch({ type: DELETE_FIELD_FAIL })
        }
    }
}

export const changeOrder = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_FIELD_ORDER_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updLeadGenOrder`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_FIELD_ORDER_SUCCESS, payload: data.order })
        }
        else if (error) {
            dispatch({ type: UPDATE_FIELD_ORDER_FAIL })
        }
    }
}

export const updateStaticField = (data, successCallback = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_STATIC_FIELD_ORDER_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updLeadGenStaticField`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_STATIC_FIELD_ORDER_SUCCESS, payload: data })
            successCallback()
        }
        else if (error) {
            dispatch({ type: UPDATE_STATIC_FIELD_ORDER_FAIL })
        }
    }
}

// Upload banner image (multipart) and persist URL as static field "BANNER"
export const uploadBannerImage = ({ survey_id, language_code, file }) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_STATIC_FIELD_ORDER_REQUEST });
        const formData = new FormData();
        formData.append('survey_id', survey_id);
        formData.append('language_code', language_code);
        formData.append('image', file);

        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/uploadLeadGenImage`,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
            showErrorToast: false
        })

        if (response) {
            const url = response.data?.data?.url;
            dispatch({
                type: UPDATE_STATIC_FIELD_ORDER_SUCCESS,
                payload: {
                    name: 'BANNER',
                    label: url,
                    language_code,
                    options: {},
                    survey_id
                }
            })
            return { success: true, url };
        } else if (error) {
            dispatch({ type: UPDATE_STATIC_FIELD_ORDER_FAIL })
            return { success: false, error };
        }
    }
}